import Class from './c-content-chart-model-linear';
import './c-content-chart-model-linear@.vue';

export default Class;